import { css } from 'styled-components';

import { DropdownTheme, SternumTheme } from '@sternum/ui';
import { Colors } from '@sternum/web/components/theme/constants';
import { getValue } from '@sternum/web/components/theme/dropdown/Dropdown.utils';

export function SBOMLightDropdownTheme(theme: SternumTheme): Partial<DropdownTheme> {
  return {
    border: `1px solid ${Colors.GreyDarkerMiddle}`,
    borderRadius: '4px',
    textColor: theme.textColor,
    fontFamily: theme.fontFamily,
    backgroundColor: Colors.Transparent,
    dropdownContainerCss: css``,
    valueContentCss: css`
      font-size: 12px;
      line-height: 20px;
    `,
    whenOpen: {
      border: `1px solid ${Colors.GreyDarkerMiddle}`,
    },
    valueWrapperCss: ({ size, disabled }) => css`
      height: ${getValue(size, { normal: 38, small: 34 })}px;
      gap: 8px;
      padding: 0 12px 0 16px;

      ${disabled &&
      css`
        color: ${Colors.GreyDarkerMiddle};
      `}

      ${!disabled &&
      css`
        &:hover {
          background: ${Colors.Lightest};
        }
      `}
    `,
    iconWrapperCss: ({ disabled }) => css`
      ${!disabled &&
      css`
        cursor: pointer;
      `}
    `,
    focusVisibleOutline: `2px solid ${theme.focusColor}`,
    focusVisibleBorderColor: Colors.AquaMiddle,
    errorBorder: `1px solid ${Colors.RedMiddle}`,
    errorTextColor: Colors.RedMiddle,
    errorHelperTextColor: Colors.RedMiddle,
  };
}
